import type { CreditCard } from "@b2bportal/card-api";
import { CallState } from "@hopper-b2b/types";
import type { PaymentError } from "./types";

export interface CardPaymentContext {
  paymentMethods: CreditCard[];
  selectedPaymentMethodId?: string;
  spreedlyToken?: string;
  error?: PaymentError;
  visited: boolean;
  validated?: boolean;
  verifyPaymentCallState?: CallState;
  /**
   * Every card verified this session, oldest first, de-duplicated by id.
   * Merged back into `paymentMethods` on every list reload, because a
   * single-use card may be missing from the card list once card lists hide
   * single-use cards.
   */
  verifiedPaymentMethods: CreditCard[];
}

export const getInitialCardPaymentContext = (): CardPaymentContext => ({
  paymentMethods: [],
  selectedPaymentMethodId: undefined,
  spreedlyToken: undefined,
  error: undefined,
  visited: false,
  validated: false,
  verifyPaymentCallState: CallState.NotCalled,
  verifiedPaymentMethods: [],
});
